<template>
    <v-card rounded="lg" flat color="grey-f7" style="overflow: unset;">
        <div class="pa-20 pa-md-30 pa-lg-40">
            <v-row align="center" class="row--large">
                <v-col cols="12" lg="6">
                    <v-select 
                        v-model="place"
                        :items= places
                        item-text= "title"
                        item-value= "_id"
                        v-bind="attrs_input" 
                        placeholder="근무지를 선택해주세요." 
                    />
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row align="center">
                        <v-col cols="12" md="auto">
                            <p class="page-text font-weight-medium min-w-md-100px min-w-lg-auto">일자별 조회</p>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-row class="row--x-small">
                                <v-col cols="12" md="">
                                    <v-row align="center" class="row--x-small">
                                        <v-col>
                                            <v-date-field v-model="filter.startsAt" v-bind="attrs_input" />
                                        </v-col>
                                        <v-col cols="auto">
                                            <p class="page-text page-text--sm">~</p>
                                        </v-col>
                                        <v-col cols="12" sm="">
                                            <v-date-field v-model="filter.endsAt" v-bind="attrs_input" />
                                        </v-col>
                                    </v-row>    
                                </v-col>
                                <v-col cols="12" md="auto">
                                    <v-btn color="primary" class="w-100" @click="searchPlace">조회</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { attrs_input, } from "@/assets/variables";
export default {
    components: {
        VDateField,
    },
    props:{
        places: { type: Array, default: ([])=> []}
    },
    data: () => ({
        place: null,
        filter:{
            startsAt: null,
            endsAt: null
        },
        attrs_input,
    }),
    methods:{
        searchPlace(){
            if(this.place){
                this.$router.push({ path: `/dashboard/worker/company/${this.place}`, query: this.filter})
            } else{
                this.$router.push({ path: `/dashboard/worker/company/${this.$route.params.place}`, query: this.filter})
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.row--x-small{
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
</style>